export default [
  {
    path: "/user",
    name: "user",
    component: () => import("./components/main-view.vue"),
    redirect: "/user/profile",
    meta: {
      title: "Profile",
    },
    children: [
      {
        path: "/user/profile",
        name: "userProfile",
        component: () => import("./components/profile-view.vue"),
        meta: { title: "Profile" },
      },
      // {
      //   path: "/user/settings",
      //   name: "userSetting",
      //   component: () => import("./components/setting-view.vue"),
      //   meta: { title: "Profile" },
      // },
    ],
  },
];
